import { useSharedCheckoutContext } from '@root/components/checkout/context';

import { ProtectionPlanNaming } from '@utils/protection_plan';
import type { IThirdPartyEventParams } from '@utils/third_party_conversion_events';

import { useCommitmentTermLength } from './use_commitment_term_length';
import { useFeeInfo } from './use_fee_info';
import { useProtectionPlanInfo } from './use_protection_plan_info';
import { useStoragePlanInfo } from './use_storage_plan_info';

export const useThirdPartyEventParams = (
  protectionPlanNaming: ProtectionPlanNaming = 'classic',
): IThirdPartyEventParams => {
  const {
    flowState: {
      values: { zip },
    },
  } = useSharedCheckoutContext();
  const storagePlanDetail = useStoragePlanInfo();
  const protectionPlanDetail = useProtectionPlanInfo(protectionPlanNaming);
  const commitmentTermLength = useCommitmentTermLength();
  const feeInfo = useFeeInfo();

  const storagePlanName = storagePlanDetail?.label;
  const protectionPlanName = protectionPlanDetail?.label;

  const storagePlanAmount = storagePlanDetail?.amount ?? 0;
  const protectionPlanAmount = protectionPlanDetail?.amount ?? 0;

  const storageTermRevenue = commitmentTermLength * storagePlanAmount;
  const protectionTermRevenue = commitmentTermLength * protectionPlanAmount;

  const totalGuaranteedRevenue =
    storageTermRevenue + protectionTermRevenue + feeInfo.totalFeeAmount;

  return {
    zip_code: zip,
    storage_plan_amount: storagePlanAmount,
    protection_plan_amount: protectionPlanAmount,
    storage_plan_name: storagePlanName,
    protection_plan_name: protectionPlanName,
    storage_term_revenue: storageTermRevenue,
    protection_term_revenue: protectionTermRevenue,
    onboarding_fee_amount: feeInfo.onboardingFeeAmount,
    final_fee_amount: feeInfo.finalFeeAmount,
    gas_fee_amount: feeInfo.gasFeeAmount,
    bundle_fee_amount: feeInfo.bundleFeeAmount,
    total_fee_amount: feeInfo.totalFeeAmount,
    total_guaranteed_revenue: totalGuaranteedRevenue,
    term_length: commitmentTermLength,
  };
};
